import _ from 'lodash';
import { dateTimeFormatter } from '../../../utilities/FormattingUtilities';

export function formatDateTime(data, selector) {
    const value = _.get(data, selector);
    return dateTimeFormatter(value);
}
